/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2021/5/12 16:30
 * @des  平台判断封装
 */

import {getPageWidth} from './size'

const Constant = require('@/base/constants')

/**
 * 判断是否为移动端屏幕
 * @param width 可选，不传时自动获取屏幕宽度
 * @returns {boolean}
 */
export function isMobile (width = -1) {
  if (width > 0) {
    return width <= Constant.CLIENT_MOBILE_WIDTH
  }
  return getPageWidth() <= Constant.CLIENT_MOBILE_WIDTH
}

/**
 * 是否是支持Touch事件的设备
 * @returns {boolean}
 */
export function isTouchDevice () {
  return 'ontouchstart' in document.documentElement
}



// WEBPACK FOOTER //
// ./src/base/util/platform.js